<div class="restricted-width-864">
  <div class="title">
    Ingreso de {{ categoriaType }} - {{ subcategoria.label }}
  </div>
  <div class="subtitle-with-line">DATOS {{ categoriaType.toUpperCase() }}</div>

  <div class="filters-container">
    <div class="filter-container filter-container-selected-eds">
      <div class="filter-title">ESTACIÓN DE SERVICIO</div>
      <div class="filter selected-eds-filter">
        <ng-select
          [items]="[
            { label: selectedEstacion?.label, value: selectedEstacion?.value },
          ]"
          class="formulario-eds-selected"
          bindLabel="label"
          bindValue="value"
          [ngModel]="selectedEstacion?.value"
          [closeOnSelect]="true"
          [clearable]="false"
          [searchable]="false"
          placeholder="Seleccionar"
          [readonly]="true"
        />
      </div>
    </div>

    @if (categoriaType === "Siniestro") {
      <div class="filter-container filter-container-heridos">
        <div class="filter-title required">¿HAY HERIDOS Y/O ARMAS?</div>
        <div class="filter">
          <ng-select
            [items]="[
              { label: 'Si', value: 'Si' },
              { label: 'No', value: 'No' },
            ]"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="heridos"
            (ngModelChange)="onHeridosChange($event)"
            [closeOnSelect]="true"
            [clearable]="false"
            [searchable]="false"
            placeholder="Seleccionar"
          />
        </div>
      </div>
    }
  </div>

  <div class="form">
    <div
      class="filter-container half-width"
      *ngFor="let field of halfWidthFields"
    >
      <div class="filter-title required">{{ field?.displayLabel }}</div>
      @if (field?.key == "telefono") {
        <div class="telefono-input-wrapper">
          <span class="telefono-prefix">+569</span>
          <input
            type="text"
            class="telefono-input"
            [(ngModel)]="userValues[field.key]"
            (ngModelChange)="updateCanSubmit()"
            maxlength="8"
            placeholder="Ingresar"
          />
        </div>
      } @else {
        <div class="filter">
          <input
            type="text"
            [(ngModel)]="userValues[field.key]"
            (ngModelChange)="updateCanSubmit()"
            placeholder="Ingresar"
          />
        </div>
      }
    </div>

    <div class="filter-container" *ngFor="let field of displayFields">
      <div class="filter-title" [class.required]="field?.required">
        {{ field?.displayLabel }}
      </div>
      <div class="filter">
        @if (field.field_type == "string" || field.field_type == "email") {
          <input
            type="text"
            [(ngModel)]="formValues[getFieldKey(field)]"
            (ngModelChange)="updateCanSubmit()"
            placeholder="Ingresar"
            [maxlength]="field.field_type == 'string' ? field.length : null"
          />
        } @else if (
          field.field_type == "double" || field.field_type == "currency"
        ) {
          <input
            type="number"
            [(ngModel)]="formValues[getFieldKey(field)]"
            (ngModelChange)="validateNumber(field)"
            (keydown)="onNumberKeyDown($event, field)"
            placeholder="Ingresar"
          />
        } @else if (field.field_type == "phone") {
          <div class="phone-input-wrapper">
            <span class="phone-prefix">+569</span>
            <input
              type="text"
              [(ngModel)]="formValues[getFieldKey(field)]"
              (ngModelChange)="updateCanSubmit()"
              (keydown)="onPhoneKeyDown($event, field)"
              placeholder="12345678"
              maxlength="8"
            />
          </div>
        } @else if (field.field_type == "textarea") {
          <textarea
            [(ngModel)]="formValues[getFieldKey(field)]"
            rows="5"
            [maxlength]="field.length"
            placeholder="Ingresar"
          ></textarea>
        } @else if (
          field.field_type == "multipicklist" || field.field_type == "picklist"
        ) {
          <ng-select
            [items]="field?.picklist_values || []"
            [closeOnSelect]="field.field_type == 'picklist'"
            [(ngModel)]="formValues[getFieldKey(field)]"
            (ngModelChange)="onPicklistChange(field, $event)"
            [clearable]="false"
            [searchable]="false"
            [multiple]="field.field_type == 'multipicklist'"
            placeholder="Seleccionar"
          />
        } @else if (field.field_type == "reference") {
          <ng-select
            [items]="field?.picklist_values || []"
            bindLabel="name"
            bindValue="id"
            [closeOnSelect]="true"
            [(ngModel)]="formValues[getFieldKey(field)]"
            (ngModelChange)="onPicklistChange(field, $event)"
            [clearable]="false"
            [searchable]="false"
            placeholder="Seleccionar"
          />
        } @else if (field.field_type == "date") {
          <p-datepicker
            [(ngModel)]="formValues[getFieldKey(field)]"
            (ngModelChange)="updateCanSubmit()"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [showButtonBar]="true"
            [locale]="es"
            [firstDayOfWeek]="1"
            placeholder="Seleccionar fecha"
          ></p-datepicker>
        } @else if (field.field_type == "datetime") {
          <p-datepicker
            [(ngModel)]="formValues[getFieldKey(field)]"
            (ngModelChange)="updateCanSubmit()"
            dateFormat="yy-mm-dd"
            [showTime]="true"
            [showIcon]="true"
            [showButtonBar]="true"
            [locale]="es"
            [firstDayOfWeek]="1"
            placeholder="Seleccionar fecha y hora"
          ></p-datepicker>
        }
      </div>
    </div>
  </div>

  <div class="subtitle-with-line">EVIDENCIA</div>

  <div class="filter-container descripcion-caso">
    <div class="filter-title required">DESCRIPCIÓN DEL CASO</div>
    <div class="filter">
      <textarea
        rows="5"
        maxlength="250"
        [(ngModel)]="descripcionCaso"
        (ngModelChange)="updateCanSubmit()"
        placeholder="Ingrese aquí una descripción del caso."
      ></textarea>
      <div class="word-counter">{{ descripcionCaso.length }}/250</div>
    </div>
  </div>
  <div class="adjuntar-evidencia-container">
    @if (!selectedEvidenceFile) {
      <button class="grey-button" (click)="onAttachEvidenceClick(fileInput)">
        <img src="assets/clip.svg" alt="adjuntar" />Adjuntar evidencia
      </button>
      <span class="info"
        >Adjuntos Máx. <b>10MB</b> ({{ allowedEvidenceFormatsLabel }})</span
      >
    } @else {
      <div class="selected-file-name">
        <div class="selected-file-name--text">{{ selectedEvidenceName }}</div>
        <img
          src="assets/cerrar-chico.svg"
          alt="cerrar"
          (click)="removeFile()"
        />
      </div>
    }
    <input
      #fileInput
      type="file"
      [accept]="allowedEvidenceAccept"
      (change)="onEvidenceSelected($event)"
      style="display: none"
    />
  </div>
  <div class="actions-container">
    <button (click)="preSubmit()" [disabled]="!canSubmit">
      Ingresar {{ categoriaType }}
    </button>
    <button class="red-button hollow" (click)="onCancel()">Cancelar</button>
  </div>
  <lib-custom-alert
    [isVisible]="showAlert"
    [closeFunc]="closeAlert"
    [acceptFunc]="acceptAlert"
    [cancelFunc]="isPresubmit ? closeAlert : undefined"
    [hideGreyBackground]="hideGreyBackground"
    [showGreyBackground]="showGreyBackground"
    [scrollTo]="scrollTo"
    [icon]="alertIcon"
    [title]="alertTitle"
    [content]="alertContent"
  >
  </lib-custom-alert>
</div>
